import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constant } from '../common/constant';
import { UserGroupRegister } from '../models/schoolRegister.model';
import { Observable } from 'rxjs';

@Injectable()
export class UserGroupService {

    constructor(private readonly http: HttpClient) {
    }

    registerUserGroup(details): Observable<UserGroupRegister> {
        const url = Constant.REST_URL + Constant.USER_GROUP + Constant.CREATE_USER_GROUP;
        return this.http.post<UserGroupRegister>(url , details);
    }

    findUserGroupById(id) {
        const url = Constant.REST_URL + Constant.USER_GROUP + Constant.GET_USER_GROUP_BY_ID + '?userGroupId=' + id;
        return this.http.get(url);
    }

    findUserGroupByAccountId(id) {
        const url = Constant.REST_URL + Constant.USER_GROUP + Constant.GET_USER_GROUP + '?accountId=' + id;
        return this.http.get(url);
    }

    getAllGroups(params, searchBy) {
        const url = Constant.REST_URL + Constant.USER_GROUP + Constant.GET_ALL_USER_GROUP
        + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy;
        return this.http.get(url);
    }

    getAllGroupsByAccountId(params, searchBy , accountId) {
        const url = Constant.REST_URL + Constant.USER_GROUP + Constant.GET_ALL_USER_GROUP_BY_ACCOUNTID + '?page='
        + (params.currentPage - 1 ) + '&size=' + params.itemsPerPage + '&sortBy=&direction=&search=' + searchBy
          + '&accountId=' + accountId;
        return this.http.get(url);
    }

    getAllRights(type,accountId) {
        const url = Constant.REST_URL + Constant.USER_GROUP + Constant.GET_RIGHTS + '?propertyType=' + type + '&accountId=' + accountId;
        return this.http.get(url);
    }

    getUsersRights(username) {
        const url = Constant.REST_URL + Constant.USER_GROUP + Constant.GET_RIGHTS_BY_USERNAME + '?username=' + username;
        return this.http.get(url);
    }
}
